import React from "react"
import { connect } from "react-redux"
import SinglePick from "./single-pick"
import * as dataFunctions from "./pick-data-functions"
import { useEFSData } from "hooks/efs-input"

const ShowBothPicks = ({
  getVatInfo
  // getPlanData,
  // getPlanCost,
  // getExtras,
  // getTotalCost,
  // getEntertainmentCost,
  // getDeviceName
}) => {
  //Grab EFS data and whether this is a VAT condition or not from the props
  const {
    // pickedDevice,
    // pickedPlan,
    // pickedExtras,
    pickedCondition,
    pickedAddEntertainment,
    // pickedStoreName,
    // picked2Device,
    // picked2Plan,
    // picked2Extras,
    picked2Condition,
    // picked2AddEntertainment,
    // picked2StoreName,
    pickedStringObject,
    picked2StringObject
  } = useEFSData()

  // Grab the device, plan and extras chosen for the two conditions from the EFS data
  const { excludeVAT, vatDivider } = getVatInfo(pickedCondition)
  const { excludeVAT_2, vatDivider_2 } = getVatInfo(picked2Condition)

  /*
  // Grab the relevant plan data for the two plans picked
  const {
    minutes,
    texts,
    data,
    contractLength,
    network,
    speed,
    speedDescription
  } = getPlanData(pickedPlan, pickedCondition)

  const {
    minutes: minutes_2,
    texts: texts_2,
    data: data_2,
    contractLength: contractLength_2,
    network: network_2,
    speed: speed_2,
    speedDescription: speedDescription_2
  } = getPlanData(picked2Plan, picked2Condition)

  // Calculate the costs for the two plans picked
  const planCost = getPlanCost(pickedDevice, pickedPlan, pickedCondition)
  const planCost_2 = getPlanCost(picked2Device, picked2Plan, picked2Condition)

  // Grab the extras
  const extras = getExtras(pickedDevice, pickedPlan, pickedExtras)
  const extras_2 = getExtras(picked2Device, picked2Plan, picked2Extras)

  // Grab the total cost
  const totalCost = getTotalCost(
    pickedDevice,
    pickedPlan,
    pickedExtras,
    pickedCondition
  )
  const totalCost_2 = getTotalCost(
    picked2Device,
    picked2Plan,
    picked2Extras,
    picked2Condition
  )

  // Grab device names
  const deviceName = getDeviceName(pickedDevice)
  const deviceName_2 = getDeviceName(picked2Device)

  const entertainmentCost = getEntertainmentCost(
    pickedAddEntertainment,
    pickedDevice
  )

  const entertainmentCost_2 = getEntertainmentCost(
    picked2AddEntertainment,
    picked2Device
  )
  */

  const planCost = {}
  const entertainmentCost = 0

  return (
    <div className="AppPicked">
      <div className="bothPicksContainer">
        <SinglePick
          storeName={pickedStringObject.storeName}
          planName={pickedStringObject.name}
          downloadSpeed={pickedStringObject.downloadSpeed}
          downloadSpeedUnit={pickedStringObject.downloadSpeedUnit}
          lineRental={pickedStringObject.lineRental}
          deviceName={pickedStringObject.device}
          contractLength={pickedStringObject.months}
          data={pickedStringObject.data}
          network={pickedStringObject.network}
          speed={pickedStringObject.speed}
          speedDescription={pickedStringObject.speedDescription}
          minutes={pickedStringObject.minutes}
          texts={pickedStringObject.texts}
          planCost={planCost}
          extras={pickedStringObject.extras}
          benefits={pickedStringObject.benefits}
          monthlyCost={pickedStringObject.monthly}
          upfrontCost={pickedStringObject.upfront}
          excludeVAT={excludeVAT}
          vatDivider={vatDivider}
          entertainmentCost={entertainmentCost}
          entertainment={pickedAddEntertainment}
        />
        <SinglePick
          storeName={picked2StringObject.storeName}
          planName={picked2StringObject.name}
          downloadSpeed={picked2StringObject.downloadSpeed}
          downloadSpeedUnit={picked2StringObject.downloadSpeedUnit}
          lineRental={picked2StringObject.lineRental}
          deviceName={picked2StringObject.device}
          contractLength={picked2StringObject.months}
          data={picked2StringObject.data}
          network={picked2StringObject.network}
          speed={picked2StringObject.speed}
          speedDescription={picked2StringObject.speedDescription}
          minutes={picked2StringObject.minutes}
          texts={picked2StringObject.texts}
          planCost={planCost}
          extras={picked2StringObject.extras}
          benefits={picked2StringObject.benefits}
          monthlyCost={picked2StringObject.monthly}
          upfrontCost={picked2StringObject.upfront}
          excludeVAT={excludeVAT_2}
          vatDivider={vatDivider_2}
          entertainmentCost={entertainmentCost}
          entertainment={pickedAddEntertainment}
        />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  getDeviceName: id => dataFunctions.getDeviceName(id)(state),
  getPlanData: (id, condition) =>
    dataFunctions.getPlanData(id, condition)(state),
  getPlanCost: (deviceID, planID, condition) =>
    dataFunctions.getPlanCost(deviceID, planID, condition)(state),
  getExtras: (deviceID, planID, extraIDs) =>
    dataFunctions.getExtras(deviceID, planID, extraIDs)(state),
  getTotalCost: (deviceID, planID, extraIDs, condition) =>
    dataFunctions.getTotalCosts(deviceID, planID, extraIDs, condition)(state),
  getVatInfo: condition => dataFunctions.getVatInfo(condition)(state),
  getEntertainmentCost: (entertainment, deviceID) =>
    dataFunctions.getEntertainmentCost(entertainment, deviceID)(state)
})

export default connect(mapStateToProps)(ShowBothPicks)
